import React from 'react';
import styled from 'styled-components';
import { FieldPermission, useSmartformContext } from '../../forms';
import { getStatusType } from './utils/useGetStatusType';
import { PermissionChip } from './PermissionChip';
import { PermissionsInformation } from './PermissionsCard/PermissionsInformation';

interface PermissionHelperProps {
  permission?: FieldPermission;
}

export const PermissionHelper: React.FC<React.PropsWithChildren<PermissionHelperProps>> = ({ permission }) => {
  const { targetEntityUid } = useSmartformContext();

  const isCustomField =
    permission?.PERMISSION_NAME?.includes('.CF') || permission?.PERMISSION_NAME?.includes('CUSTOM_FIELD');

  const canViewPermissionChips = permission === undefined || !!permission?.PERMISSION_NAME || isCustomField;

  return (
    <>
      {canViewPermissionChips && (
        <StyledContainer>
          <StyledChipContainer>
            <PermissionChip
              permission={permission}
              type={getStatusType(permission, 'READ')}
              permissionKey="READ"
              text="R"
            />
            <PermissionChip
              permission={permission}
              type={getStatusType(permission, 'UPDATE')}
              permissionKey="WRITE"
              text="W"
            />
          </StyledChipContainer>
          <PermissionsInformation permission={permission} resourceUid={targetEntityUid} />
        </StyledContainer>
      )}
    </>
  );
};

const StyledChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  width: 100%;
  margin: 8px 0;
`;

const StyledContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 8px;
  width: fit-content;
`;
